import styled, { Color, Spacing, Font, Breakpoint } from '@nfinite/react-hubstairs/styled'

import ButtonComponent from 'components/Commons/Button'
import IconComponent from 'components/Commons/Icon'

export const Container = styled('div')`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  ${Spacing.generatePadding({ horizontal: 'xl' })}
`

export const Title = styled('div')`
  font-size: 40px;
  color: ${Color.get('text')};
  ${Font.generate({ weight: 'bold' })}
  ${Spacing.generateMargin({ bottom: 'm', top: 'l' })}
`

export const Message = styled('div')`
  ${Font.generate({ size: 'm' })}
  color: ${Color.get('text', 'gray')};
`

export const Icon = styled(IconComponent)`
  position: relative;
  width: 56px;

  & > svg {
    fill: ${Color.get('gray', 'dark')};
  }
`

export const Button = styled(ButtonComponent)`
  ${Spacing.generateMargin({ top: 'l', horizontal: 'auto' })}

  ${Breakpoint.greaterOrEqualThan('sm')} {
    ${Spacing.generateMargin({ horizontal: '0' })}
  }
`
